module.exports = __webpack_public_path__ + "static/media/regulament-oferta-speciala-voucher-noul-nissan-juke_v3_final.15d4b9ce.pdf";